export default function Footer() {
  return (
    <footer className="tw-bg-gray-900 tw-text-white">
      <div className="tw-max-w-7xl tw-mx-auto tw-px-4 tw-py-12">
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-4 tw-gap-8">
          <div>
            <img
              src="/images/MOM-logo.png"
              alt="SoFest Logo"
              className="tw-h-20 tw-mb-4"
            />
            <p className="tw-text-gray-400">
              The ultimate ski and music festival experience in Beijing, China.
            </p>
          </div>

          <div>
            <h4 className="tw-text-lg tw-font-bold tw-mb-4">Quick Links</h4>
            <ul className="tw-space-y-2">
              <li>
                <a
                  onClick={() => (window.location.href = "/")}
                  className="tw-text-gray-400 hover:tw-text-white tw-transition-colors"
                >
                  Home
                </a>
              </li>
              <li>
                <a
                  onClick={() =>
                    window.open("https://sotravel.com/trip/1948", "_blank")
                  }
                  className="tw-text-gray-400 hover:tw-text-white tw-transition-colors"
                >
                  Tickets
                </a>
              </li>

              <li>
                <a
                  onClick={() =>
                    window.open("https://sotravel.com/trip/1948", "_blank")
                  }
                  className="tw-text-gray-400 hover:tw-text-white tw-transition-colors"
                >
                  Accommodation
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="tw-text-lg tw-font-bold tw-mb-4">Information</h4>
            <ul className="tw-space-y-2">
              <li>
                <a
                  onClick={() =>
                    window.open(
                      "https://sotravel.com/reserve?trip_id=1948",
                      "_blank"
                    )
                  }
                  className="tw-text-gray-400 hover:tw-text-white tw-transition-colors"
                >
                  Pricing
                </a>
              </li>
              <li>
                <a
                  onClick={() =>
                    window.open(
                      "https://sotravel.com/reserve?trip_id=1948",
                      "_blank"
                    )
                  }
                  className="tw-text-gray-400 hover:tw-text-white tw-transition-colors"
                >
                  Beginner lessons
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="tw-text-gray-400 hover:tw-text-white tw-transition-colors"
                >
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="tw-text-lg tw-font-bold tw-mb-4">Connect With Us</h4>
            <div className="tw-flex tw-space-x-4 tw-mb-4">
              <a
                onClick={() =>
                  window.open("https://instagram.com/sotravel_sg", "_blank")
                }
                className="tw-text-gray-400 hover:tw-text-white tw-transition-colors"
              >
                Instagram
              </a>
              <a
                onClick={() =>
                  window.open("https://tiktok.com/@sotravel_sg", "_blank")
                }
                className="tw-text-gray-400 hover:tw-text-white tw-transition-colors"
              >
                TikTok
              </a>
            </div>
          </div>
        </div>

        <div className="tw-mt-8 tw-pt-8 tw-border-t tw-border-gray-700 tw-text-center">
          <p className="tw-text-gray-400">
            &copy; {new Date().getFullYear()} SoFest - The Mountain of Madness.
            All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
